import { notificationApi } from "../../../api/apiClient"


function GroupList(){
    return notificationApi.get("/notifications/groups")
}

function CreateGroups(data) {
    return notificationApi.post("/notifications/groups/add", data)
}

function EditGroup(data){
    return notificationApi.put("/notifications/groups/update",data)
}

function RemoveGroup(id)
{
    return notificationApi.put(`/notifications/groups/delete/${id}`)
}

function LoadSubscribers(data)
{
    return notificationApi.post("/notifications/customers", data)
}

function AssginToGroup(data){
    return notificationApi.post(`/notifications/groups/${data.id}/customers/assign`,data)
}

function GetSubscriberByGroup (data)
{
    return notificationApi.post(`/notifications//groups/${data.searchCriteria}/customers`,data)
}

function RemoveCustomerFromGroup (data) {
    return notificationApi.put(`notifications/groups/${data.id}/customers/delete`,data)
}
export const CustomerGroups = { 
    GroupList,
    CreateGroups,
    RemoveGroup,
    LoadSubscribers,
    GetSubscriberByGroup,
    RemoveCustomerFromGroup,
    EditGroup,
    AssginToGroup
};

